import {RAW_TAB_TO_TAB_KEY} from '../../../home/common/type';
import {routeTo} from '../../util/PageRouter';
import Anchor from '../Anchor';
import EllipsisText from '../EllipsisText';
import PageImage from '../PageImage';
import SingleText from '../SingleText';

interface IProps {
  thumbImg: string;
  landingUri: string;
  bgColor: string;
  textColor: string;
  title: string;
  subTitle?: string;
}

export default function TalkBoard({
  thumbImg,
  landingUri,
  bgColor,
  textColor,
  title,
  subTitle,
}: IProps) {
  return (
    <div
      className="flex-center h-68 rounded-8"
      style={{
        // TODO: F3F3F3 컬러 명 추가 요청하자
        backgroundColor: bgColor || '#F3F3F3',
      }}
    >
      <Anchor
        pageInfo={landingUri}
        display="flex"
        className="w-full h-full flex-center"
        onClick={
          Object.keys(RAW_TAB_TO_TAB_KEY).find(key => landingUri.includes(key))
            ? () => {
                routeTo(landingUri, {isShallow: false});
              }
            : undefined
        }
      >
        <div className="self-center overflow-hidden flex-none w-[176px]">
          <EllipsisText
            line={subTitle ? 1 : 2}
            className={cn(
              's13-bold-grey04',
              !textColor && '!text-dark-grey-04',
              'tracking-[-0.6px]',
              {
                'leading-17': !!subTitle,
                'leading-18': !subTitle,
              }
            )}
            style={textColor ? {color: textColor} : undefined}
          >
            {title}
          </EllipsisText>
          {subTitle && (
            <SingleText
              className={cn(
                's11-medium-grey04',
                !textColor && '!text-dark-grey-04',
                'mt-3 opacity-80 leading-15 tracking-[-0.4px]'
              )}
              style={textColor ? {color: textColor} : undefined}
            >
              {subTitle}
            </SingleText>
          )}
        </div>
        <PageImage
          src={thumbImg}
          alt=""
          pictureClassName={cn(
            'h-full ml-7 flex-center overflow-hidden',
            'flex-none w-92'
          )}
          className="h-full"
        />
      </Anchor>
    </div>
  );
}
